// extracted by mini-css-extract-plugin
export default {"skipLink":"SkipToMainContent_skipLink__JzqwQ"};